import React, { useEffect, useState } from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import logoFiltro from '../assets/Filter.png';
import mesaEmpresa from '../assets/mesa.png';
import { arreglarReloj, handleError, imprimirSeccion, toastError, toastSuccess } from '../funciones';
import axios from '../axiosConfig';
import { TablaN } from './TablaN';
import { ImprimirEmpresasInscriptas } from './ImprimirEmpresasInscriptas';
import { FiltrosAdmin } from './FiltrosAdmin';
import logoAsistencia from '../assets/asistencia.png';
import cruzCierre from '../assets/cruzBlanca.png';
import { ViewProfileCompany } from './ViewProfileCompany';
import { useInscriptionsQuery } from '../hooks/useInscriptionsQuery';
import { BooleanToggleActions } from './BooleanToggleActions';
import { useAnimatedMount } from '../hooks/useAnimatedMount'; 
import { ModalAgregarMesa } from './ModalAgregarMesa';

export const EmpresasInscriptas = ({ evento, funciones, nombreBuscar, show }) => {

    const [inscripcion, setInscripcion] = useState({});
    const [empresa, setEmpresa] = useState({});
    const [asistencia, setAsistencia] = useState('0');
    const [mostrarAsistencia, setMostrarAsistencia] = useState(false);
    const [loadingMap, setLoadingMap] = useState({});
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const { mounted, visible } = useAnimatedMount(show);

    const getKey = (id, type) => `${id}-${type}`;

    const itemsFiltro = [
        {
            setValue: setAsistencia, value: asistencia, id: "asistencia", text: "Tipo de asistencia",
            items: ["Todas", "Pendientes", "Asistieron", "No asistieron"]
        }
    ];

    const { companies, loading, updateInscription, updateCompany } = useInscriptionsQuery({
        url: "empresa/verEmpresasDeUnEvento",
        params: { eventoId: evento?.id },
        enabled: !!evento?.id
    });

    useEffect(() => {
        if (show) funciones.updateHandlerRef.current = updateCompany;
    }, [updateCompany, show]);

    const selectedCompany = companies?.find(
        c => c.empresaPerfilFullView.id === selectedCompanyId
    )?.empresaPerfilFullView;

    useEffect(() => {
        selectedCompany && show && funciones.setSelectedCompany(selectedCompany)
    }, [selectedCompany])

    const mostrarEmpresa = (elem) => {
        var nombreAprobado = true
        if (nombreBuscar.localeCompare("") !== 0 && !elem.empresaPerfilFullView.nombre.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
            .includes(nombreBuscar.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")))
            nombreAprobado = false
        return (asistencia === "0" || (asistencia === "1" && elem.inscripcionView.asistio === null)
            || (asistencia === "2" && elem.inscripcionView.asistio) ||
            (asistencia === "3" && elem.inscripcionView.asistio === false)) && nombreAprobado
    }

    const contenidoFila = (elem) => {
        return <>

            <div className='col'>
                {elem.empresaPerfilFullView.nombre}
            </div>
            {evento.aprobarEmpresas && <div className='col-3 text-center'>
                {elem.inscripcionView.aprobada ? <>
                    <div className='d-md-none'>Si</div>
                    <div className='d-md-block d-none'>Aprobado</div>
                </> : elem.inscripcionView.aprobada === false ? <>
                    <div className='d-md-none'>No</div>
                    <div className='d-md-block d-none'>Desaprobado</div>
                </> : <>
                    <div className='d-md-none'>-</div>
                    <div className='d-md-block d-none'>Pendiente</div>
                </>}
            </div>}
            <div className='col-3 text-end align-items-center justify-content-end  d-flex gap-3 flex-wrap'>
                {evento.aprobarEmpresas &&
                    <BooleanToggleActions
                        value={elem.inscripcionView.aprobada}
                        loading={isLoading(elem.inscripcionView.id, "aprobacion")}
                        onTrue={() => cambiarAprobacion(elem.inscripcionView.id, true)}
                        onFalse={() => cambiarAprobacion(elem.inscripcionView.id, false)}
                        noMargin
                    />
                }

                {evento.permiteReuniones && evento.poseeMesasReservadas &&
                    <div className='cursor-pointer containerBtnMesaFija' onClick={() => ponerMesaFija(elem)} data-bs-target="#modalMesaFija" data-bs-toggle="modal">
                        {elem.inscripcionView.numeroDeMesaReservada && <span className='d-block text-center numeroMesaFija'>{elem.inscripcionView.numeroDeMesaReservada}</span>}
                        <img id={"mesaFija"} className=' img-blanco-mobile' src={mesaEmpresa} alt="" />
                    </div>
                }


                <ViewProfileCompany companyId={elem.empresaPerfilFullView.id} onSelect={setSelectedCompanyId} noMargin />
            </div>
            <div className={`col-6 d-flex  px-0 columnaAsistencia h-100 ${mostrarAsistencia ? 'mostrar' : ''}`}>
                <div className='col-7 col-md-6 text-center align-self-center'>
                    {elem.inscripcionView.asistio ? <>
                        <div className='d-sm-none'>Si</div>
                        <div className='d-sm-block d-none'>Presente</div>
                    </> : elem.inscripcionView.asistio === false ? <>
                        <div className='d-sm-none'>No</div>
                        <div className='d-sm-block d-none'>Ausente</div>
                    </> : <>
                        <div className='d-sm-none'>-</div>
                        <div className='d-sm-block d-none'>Pendiente</div>
                    </>}
                </div>
                <div className='col text-end align-items-center justify-content-end pe-sm-3 d-flex'>
                    <BooleanToggleActions
                        value={elem.inscripcionView.asistio}
                        loading={isLoading(elem.inscripcionView.id, "aprobacion")}
                        onTrue={() => cambiarAsistencia(elem.inscripcionView.id, true)}
                        onFalse={() => cambiarAsistencia(elem.inscripcionView.id, false)}
                    />
                    <div className='d-none d-md-block'>
                        <ViewProfileCompany companyId={elem.empresaPerfilFullView.id} onSelect={setSelectedCompanyId} />
                    </div>
                </div>
            </div>
        </>
    }

    const setLoading = (id, type, value) => {
        const key = getKey(id, type);

        setLoadingMap(prev => ({
            ...prev,
            [key]: value
        }));
    }

    function isLoading(id, type) {
        return !!loadingMap[getKey(id, type)];
    }

    const cambiarAprobacion = (id, aprobado) => {
        setLoading(id, "aprobacion", true);

        const params = {
            params: {
                inscripcionId: id,
                aprobar: aprobado
            }
        }
        axios
            .put(process.env.REACT_APP_URL + "inscripcion/cambiarEstadoAprobacion", null, params)
            .then((res) => {
                updateInscription(id, { aprobada: aprobado });
                toastSuccess(aprobado ? "Aprobación registrada" : "Desaprobación registrada")

            })
            .catch(function (error) {
                toastError(handleError(error))
            })
            .finally(() => {
                setLoading(id, "aprobacion", false);
            });
    }

    const cambiarAsistencia = (id, asistio) => {
        setLoading(id, "asistencia", true);

        const params = {
            params: {
                inscripcionId: id,
                asistio: asistio
            }
        }
        axios
            .put(process.env.REACT_APP_URL + "inscripcion/registrarAsistencia", null, params)
            .then((res) => {
                updateInscription(id, { asistio: asistio });
                toastSuccess(asistio ? "Asistencia registrada" : "Ausencia registrada")
            })
            .catch(function (error) {
                toastError(handleError(error))
            })
            .finally(() => {
                setLoading(id, "asistencia", false);
            });
    }

    const ponerMesaFija = (ins) => {
        setInscripcion(ins.inscripcionView);
        setEmpresa(ins.empresaPerfilFullView);
    }

    const mostrarFiltros = () => {
        document.getElementById("containerFiltros").classList.remove("ocultarFiltros")
        document.getElementById("filtroOverlay").classList.remove("ocultarFiltros")
    }

    return (
        <>
            {mounted && <>

                <TablaN elementos={companies} id={'containerInscriptos'} classNameTabla={visible ? "transform-none" : ''}
                    classNameFilas={'ps-0 pe-0 showBorderFilaMobile'}
                    itemsEncabezado={[{
                        className: 'col', text: <>
                            <div className='d-md-none'>Empresas</div><div className='d-md-block d-none'>Empresas inscriptas</div>
                        </>
                    },
                    ...(evento.aprobarEmpresas
                        ? [{
                            className: 'col-3 text-center px-0', text: <>
                                <div className='d-md-none'>Aprobar</div><div className='d-md-block d-none'>Estado</div>
                            </>
                        }]
                        : []),
                    {
                        className: 'pe-2 centrarContainer gap-3 flex-wrap col-3 justify-content-end',
                        text: <>
                            <img src={logoFiltro} className='cursor-pointer mobile-white d-inline-block' alt="" onClick={mostrarFiltros} />
                            <img src={logoAsistencia} className='cursor-pointer mobile-white d-inline-block' alt="" onClick={() => setMostrarAsistencia(!mostrarAsistencia)} />
                            <div className='logoImprimir logoImprimirEmpresasInscriptas d-inline-block' alt=""
                                onClick={() => imprimirSeccion({
                                    idSeccion: "imprimirEmpresasInscriptas"
                                })} />
                        </>
                    }, {
                        className: `col-6 columnaAsistencia header h-100 px-0 ${mostrarAsistencia ? 'mostrar' : ''}`,
                        text: <div className='d-flex w-100 py-3 headerRowAsistencia'>
                            <div className='col-7 col-md-6 text-center'>
                                <div className='d-sm-none'>Presente</div><div className='d-sm-block d-none'>Asistencia</div>
                            </div>
                            <div className='col text-end'>
                                <img src={logoFiltro} className='cursor-pointer me-3 mobile-white d-inline-block' alt="" onClick={mostrarFiltros} />
                                <img src={cruzCierre} className='cursor-pointer me-3 img-blanco-mobile d-inline-block imgBlack' alt="" onClick={() => setMostrarAsistencia(!mostrarAsistencia)} />
                            </div>
                        </div>
                    }]}
                    itemsFilas={contenidoFila} elemNoEncontrado={'empresas'}
                    mostrarElem={mostrarEmpresa} mostrarLoader={loading} />
                <FiltrosAdmin itemsFiltro={itemsFiltro} />
                <ImprimirEmpresasInscriptas evento={evento} empresas={companies.map(elemento => elemento.empresaPerfilFullView)} />
            </>
            }
            {evento.permiteReuniones && <ModalAgregarMesa inscripcion={inscripcion} empresa={empresa} evento={evento} updateInscription={updateInscription} />}
        </>
    );
}
